export default __webpack_public_path__ + "static/media/5t.9fe5f5b5.jpg";